import { render } from "./SelectComponent.vue?vue&type=template&id=60f50a7f&scoped=true"
import script from "./SelectComponent.vue?vue&type=script&lang=js"
export * from "./SelectComponent.vue?vue&type=script&lang=js"

import "./SelectComponent.vue?vue&type=style&index=0&id=60f50a7f&lang=scss"
import "./SelectComponent.vue?vue&type=style&index=1&id=60f50a7f&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f50a7f"]])

export default __exports__